/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-10-17 17:22:11
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import { RootDispatch } from '../../../app/store'
import styles from './OralCases.module.css'
import { EditableList } from '../../../compnents/list/EditableList'
import { InformedConsentPrintColumns } from './column'
import { getSelectOralInformedBookAsync } from './oralCasesSlice'

const { Option } = Select

export const InformedConsentPrintModal = (props: {
  pageModalLoading: boolean
  patientId: any
  treatmentId: any
  isModalVisible: boolean
  dataList: any[]
  onOk: () => void
  onCancel: () => void
  onPrint?: (item: any) => void
  scanTheCodeToSign?: (item: any) => void
}) => {
  const dispatch = useDispatch<RootDispatch>()

  return (
    <>
      <Modal
        width={800}
        title={'知情同意书'}
        visible={props.isModalVisible}
        footer={null}
        className={styles.informedConsentPrintModal}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <EditableList
          loading={props.pageModalLoading}
          page={{
            size: 10,
            current: 1,
            total: 0,
            items: props?.dataList || [],
          }}
          scroll={{ y: 480, x: 'auto' }}
          pagination={false}
          columns={InformedConsentPrintColumns(async (text, item) => {
            if (text == 'scanTheCodeToSign') {
              props?.scanTheCodeToSign && props?.scanTheCodeToSign(item)
            } else if (text === 'print') {
              props?.onPrint && props?.onPrint(item)
            }
          })}
        />
      </Modal>
    </>
  )
}
